export class UpdateBraintreeDropInAction {
  static readonly type = '[UI] Update Braintree Drop In';
  constructor(public updateState: boolean) {
  }
}
